<template>
  <div class="score bg-text-lighter">
    <div class="score-header">
      <van-nav-bar
        class="score-nav mb2"
        @click-left="leavePage"
        @click-right="toSearch"
        left-text="退出"
        left-arrow
      >
        <div class="score-nav-title van-ellipsis primary" slot="title">
          {{ meetName }}
          <span class="h6 pl1 text-light">{{ allCount }}人</span>
        </div>
        <van-icon slot="right" name="search" size="15px"/>
      </van-nav-bar>
      <van-tabs
        v-model="activeTab"
        class="score-tab mx-auto"
        @change="handleTabChange"
        :line-width="35"
        type="card"
        color="#409eff"
        animated
      >
        <van-tab>
          <template slot="title">
            <div class="inline">未评分</div>
            <div class="score-tab-count inline h6 pl1">{{ unscoreCount }}人</div>
          </template>
        </van-tab>
        <van-tab>
          <template slot="title">
            <div class="inline">已评分</div>
            <div class="score-tab-count inline h6 pl1">{{ scoredCount }}人</div>
          </template>
        </van-tab>
      </van-tabs>
    </div>
    <swiper
      ref="swiper"
      class="score-body"
      :options="swiperOption"
      @slideChange="handleSlideChange"
    >
      <swiper-slide class="score-swiper-item">
        <user-score-list ref="scoreList0" @update-all-count="updateAllCount"/>
      </swiper-slide>
      <swiper-slide class="score-swiper-item">
        <user-score-list
          ref="scoreList1"
          :style="{ height: swiperHeight  }"
          @update-scored-count="updateScoredCount"
          saved
        />
      </swiper-slide>
    </swiper>

    <user-score-search
      v-if="showSearch"
      ref="scoreSearch"
      v-model="showSearch"
      @update-user-list="updateUserList"
    />
  </div>
</template>

<script>
import { logout } from '@/utils/user'
import { getMeet } from '@/utils/score'
import Bus from '@/utils/eventBus'
import UserScoreList from './components/UserScoreList'
import UserScoreSearch from './components/UserScoreSearch'
export default {
  name: 'Score',
  components: {
    UserScoreList,
    UserScoreSearch
  },
  data() {
    return {
      activeTab: 0,
      scrollTop: 0,
      showSearch: false,
      meetName: getMeet() || '年终会议评分系统',
      swiperHeight: null,
      swiperOption: {},
      allCount: 0,
      scoredCount: 0
    }
  },
  computed: {
    swiper() {
      return this.$refs['swiper'].swiper
    },
    unscoreCount() {
      const unscoreCount = this.allCount - this.scoredCount
      return unscoreCount < 0 ? 0 : unscoreCount
    }
  },
  created() {
    Bus.$on('change-scored-count', value => {
      this.scoredCount += value
    })
  },
  watch: {
    activeTab(newValue) {
      this.updateUserList(newValue)
    }
  },
  methods: {
    handleTabChange(index) {
      this.$nextTick(() => {
        this.swiper.slideTo(index, 400, false)
      })
    },
    handleSlideChange() {
      this.activeTab = this.swiper.realIndex
    },
    updateUserList(index = this.activeTab) {
      this.$refs[`scoreList${index}`].mescroll.resetUpScroll(false)
    },
    updateAllCount(count) {
      this.allCount = count
    },
    updateScoredCount(count) {
      this.scoredCount = count
    },
    leavePage() {
      this.$dialog
        .confirm({
          title: '您确定离开吗？'
        })
        .then(() => void logout())
        .catch(() => {})
    },
    getBindNode() {
      return document.querySelector('body')
    },
    toSearch() {
      this.showSearch = true
    }
  }
}
</script>

<style lang="less" scoped>
.score {
  height: 100%;
  .score-header {
    height: 100px;
    z-index: 99;
    .score-nav {
      height: 46px;
      line-height: 46px;
      box-shadow: 0 1px 10px rgba(0, 0, 0, 0.06);
      .score-nav-title {
        font-size: 15px;
      }
    }
    .score-tab {
      width: 70%;
      .score-tab-count {
        color: #c0c4cc;
      }
      /deep/.van-tab--active {
        .score-tab-count {
          color: white;
        }
      }
    }
  }
  .score-body {
    height: calc(100% - 100px);
  }
}
</style>
